export default "assets/images/icons/arrow-12d11cb9.svg";